import createIcon from '../../createIcon';

/**
 * @component @name Architecture
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNi4zNTU0NyAxOC43OEw2LjYwNTQ3IDIxTDguMjI1NDcgMTkuNDZMMTAuOTk1NSAxMS44NkMxMC4zMTU1IDExLjY5IDkuNzE1NDcgMTEuMzUgOS4yMjU0NyAxMC44OEw2LjM1NTQ3IDE4Ljc4WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE0Ljc2NTUgMTAuODhDMTQuMjc1NSAxMS4zNSAxMy42NjU1IDExLjY5IDEyLjk5NTUgMTEuODZMMTUuNzY1NSAxOS40NkwxNy4zODU1IDIxTDE3LjY0NTUgMTguNzhMMTQuNzY1NSAxMC44OFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNC45OTU1IDhDMTQuOTk1NSA2LjcgMTQuMTU1NSA1LjYgMTIuOTk1NSA1LjE4VjNIMTAuOTk1NVY1LjE4QzkuODM1NDcgNS42IDguOTk1NDcgNi43IDguOTk1NDcgOEM4Ljk5NTQ3IDkuNjYgMTAuMzM1NSAxMSAxMS45OTU1IDExQzEzLjY1NTUgMTEgMTQuOTk1NSA5LjY2IDE0Ljk5NTUgOFpNMTEuOTk1NSA5QzExLjQ0NTUgOSAxMC45OTU1IDguNTUgMTAuOTk1NSA4QzEwLjk5NTUgNy40NSAxMS40NDU1IDcgMTEuOTk1NSA3QzEyLjU0NTUgNyAxMi45OTU1IDcuNDUgMTIuOTk1NSA4QzEyLjk5NTUgOC41NSAxMi41NDU1IDkgMTEuOTk1NSA5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Architecture = createIcon('Architecture', [
  [
    'path',
    {
      d: 'M6.35547 18.78L6.60547 21L8.22547 19.46L10.9955 11.86C10.3155 11.69 9.71547 11.35 9.22547 10.88L6.35547 18.78Z',
      key: 'eevi5',
    },
  ],
  [
    'path',
    {
      d: 'M14.7655 10.88C14.2755 11.35 13.6655 11.69 12.9955 11.86L15.7655 19.46L17.3855 21L17.6455 18.78L14.7655 10.88Z',
      key: '1blut5',
    },
  ],
  [
    'path',
    {
      d: 'M14.9955 8C14.9955 6.7 14.1555 5.6 12.9955 5.18V3H10.9955V5.18C9.83547 5.6 8.99547 6.7 8.99547 8C8.99547 9.66 10.3355 11 11.9955 11C13.6555 11 14.9955 9.66 14.9955 8ZM11.9955 9C11.4455 9 10.9955 8.55 10.9955 8C10.9955 7.45 11.4455 7 11.9955 7C12.5455 7 12.9955 7.45 12.9955 8C12.9955 8.55 12.5455 9 11.9955 9Z',
      key: 'h65j6d',
    },
  ],
]);

export default Architecture;
